import { getTeamsDateFormat, getTeamsTimeFormat } from "../utils/dateUtils";

const pl = {
    common: {
        loader: "Loading data...",
        meetingCancelled: "The meeting has been cancelled",
    },
    logo: {
        corporation: "mBank logo for Corporate Banking",
        retail: "mBank logo for Retail Banking",
        private: "mBank logo for Private Banking",
    },
    requestCancelMeeting: {
        actionButton: "Send request",
        pendingDescription: (startAt: Date) =>
            `Do you want to send a request to the organizer to cancel the meeting
            on ${getTeamsDateFormat(startAt)} at ${getTeamsTimeFormat(startAt)}?`,
        inProgressDescription: (startAt: Date) =>
            `The meeting on ${getTeamsDateFormat(startAt)} at ${getTeamsTimeFormat(
                startAt
            )} has already started or will start in a moment.
            You cannot cancel it anymore. If you need to cancel the meeting, contact your advisor.`,
        expiredDescription: (endAt: Date) =>
            `The meeting ended on ${getTeamsDateFormat(endAt)} at ${getTeamsTimeFormat(
                endAt
            )}.\nYou cannot cancel it anymore.`,
        requestSent:
            "A request to cancel the meeting has been sent. Your advisor will get in touch with you soon to confirm the cancellation.",
        redirectButton: "Do not send",
    },
    joinMeeting: {
        meetingNotFound: "The meeting has not been found. The link may be incorrect. Check the link and try again.",
        actionButton: "Start meeting",
        redirectButton: "Cancel meeting",
        pendingDescription: (startAt: Date) =>
            `The meeting will start on ${getTeamsDateFormat(startAt)} at  ${getTeamsTimeFormat(
                startAt
            )}.\nYou can join it 10 minutes before the meeting starts.`,
        inProgressDescription:
            "The meeting will start soon and will be recorded.\nIf you do not consent to being recorded, click the Cancel Meeting button",
        expiredDescription: (endAt: Date) =>
            `The meeting ended on ${getTeamsDateFormat(endAt)} at ${getTeamsTimeFormat(
                endAt
            )}.\nYou cannot join it anymore.`,
        wrongAddress:
            "The meeting link is incorrect. Check if the link in the address bar of your browser matches the link sent by email.",
        failedToJoin: "You were unable to join the meeting. The link may be incorrect. Check the link and try again.",
        browserUnsupportedError: (recommendedBrowsers: string) =>
            `You are using an unsupported browser. We recommend using the latest version of one of the following browsers: ${recommendedBrowsers}`,
    },
};

export default pl;
